import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Variant = 'default' | 'success' | 'warning' | 'error' | 'info';

const VARIANTS: Record<Variant, string> = {
  default: 'bg-gray-100 text-gray-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-orange-100 text-brand-primary',
  error: 'bg-red-100 text-error',
  info: 'bg-blue-100 text-blue-700',
};

export interface BadgeProps {
  variant?: Variant;
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
}

export function Badge({ variant = 'default', children, className, icon }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        VARIANTS[variant],
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
